import { Header } from '@/components/DashboardComponents'
import { useNavigate } from 'react-router'
import { GenericEmptyListPlaceholder } from '@/DashboardLayout'
import { Icon } from '@/components/Icon'
import { useUser, useIsSuperAdmin, refreshUserdata } from '@/systems/Authentication'
import { useModal, Modal, ModalContent, ModalButtons } from '@/components/Modal'
import { FormProvider, FormSubmitProvider} from '@/form/FormProvider'
import { Textbox, Button, Spacing } from '@/form/FormComponents'
import { publicAction } from '@/data/loaders'

export function Organizations() {
  const navigate = useNavigate();
  const { userdata } = useUser();
  const superadmin = useIsSuperAdmin();
  const manager_organizations = userdata.organizations.filter(o => o.roles.includes("admin"));

  const [openNewOrganizationModal] = useModal(function ({ closeModal, setLoading }) {
    function submitCreate({ formatted_data, focusError }) {
      setLoading(true);

      publicAction("createRootOrganization", {
        data: {
          name: formatted_data.name,
          shortname: formatted_data.shortname
        }
      }).then(function(response) {
        setLoading(false);
        closeModal();
        refreshUserdata();
        navigate(".", { replace: true });
      }).catch(function(error) {
        setLoading(false);
        focusError({name: "name", error: "Something went wrong, please try again."});
        console.error(error);
      })
    }

    return (
      <Modal title="Create root organization">
        <FormProvider onSubmit={submitCreate}>
          <FormSubmitProvider>
            {({handleSubmit}) => (
              <>
                <ModalContent>
                  <Textbox name="name" title="Name" required={true} />
                  <Spacing/>
                  <Textbox name="shortname" title="Short name" required={true} />
                </ModalContent>
                <ModalButtons>
                  <Button text="Cancel" className="hollow" onClick={closeModal}/>
                  <Button text="Submit" className="primary" onClick={handleSubmit}/>
                </ModalButtons>
              </>
            )}
          </FormSubmitProvider>
        </FormProvider>
      </Modal>
    )
  });

  return (
    <>
      <Header title="Organizations">
        {superadmin && (
          <Button text="New organization" icon="plus" onClick={openNewOrganizationModal}/>
        )}
      </Header>
      <div className="dashboard_content_inner nearest_scrollable_container">
        <div className="dashboard_content_container">
          {
            manager_organizations.length > 0 ? (
              <div className="scenario_list" columns="1">
                {manager_organizations.sort((a, b) => b.data.name.localeCompare(a.data.name)).map((organization) => <OrganizationItem key={organization.data._id} organization={organization}/>)}
              </div>
            ) : <GenericEmptyListPlaceholder text="You aren't a manager of any organizations" icon="domain"/>
          }
        </div>
      </div>
    </>
  )
}

function OrganizationItem({organization}) {
  const navigate = useNavigate();

  return (
    <div className="scenario_item" onClick={() => {navigate("/organizations/"+organization.data._id)}} tabIndex={0}>
      <div className="item_icon">
        <Icon name="domain"/>
      </div>
      <div className="item_title">{organization.data.name}</div>
    </div>
  )

}